export const SRHT_EXCLUSION_MAX_REPORTS = 9;

export function buildEmptySrhtExclusionReport(sortOrder = 0) {
  return {
    reportDate: '',
    reportText: '',
    sortOrder,
  };
}

export function buildInitialSrhtExclusionForm(record = null) {
  const reports = Array.isArray(record?.reports) && record.reports.length > 0
    ? record.reports.map((report, index) => ({
      reportDate: report?.reportDate || '',
      reportText: report?.reportText || '',
      sortOrder: Number.isInteger(report?.sortOrder) ? report.sortOrder : index,
    }))
    : [buildEmptySrhtExclusionReport(0)];

  return {
    detailedReasonText: record?.detailedReasonText || '',
    reports,
    hearingUserIds: Array.isArray(record?.hearingUsers) ? record.hearingUsers.map((item) => Number(item.id)).filter(Number.isInteger) : [],
    exclusionConfirmed: Boolean(record?.exclusionConfirmed),
    participantNotifiedDate: record?.participantNotifiedDate || '',
  };
}

export function getLatestSrhtExclusionReportDate(reports = []) {
  return (Array.isArray(reports) ? reports : []).reduce((latest, report) => {
    const reportDate = String(report?.reportDate || '').trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(reportDate)) {
      return latest;
    }
    if (!latest || reportDate > latest) {
      return reportDate;
    }
    return latest;
  }, '');
}

export function validateSrhtExclusionForm(form = {}, course = {}, options = {}) {
  const requireFinalize = Boolean(options.requireFinalize);
  const courseStart = String(course?.start_date || course?.startDate || '').trim();
  const courseEnd = String(course?.end_date || course?.endDate || '').trim();
  const reports = Array.isArray(form?.reports) ? form.reports : [];

  const incompleteReportIndexes = [];
  const outOfRangeReportIndexes = [];
  let completedReportCount = 0;

  reports.forEach((report, index) => {
    const reportDate = String(report?.reportDate || '').trim();
    const reportText = String(report?.reportText || '').trim();
    if (!reportDate && !reportText) {
      return;
    }

    const isComplete = Boolean(reportDate && reportText);
    if (!isComplete) {
      incompleteReportIndexes.push(index);
    }

    if (reportDate && reportText) {
      completedReportCount += 1;
    }

    if (reportDate && courseStart && courseEnd && (reportDate < courseStart || reportDate > courseEnd)) {
      outOfRangeReportIndexes.push(index);
    }
  });

  const participantNotifiedDate = String(form?.participantNotifiedDate || '').trim();
  const latestReportDate = getLatestSrhtExclusionReportDate(reports);

  const participantNotifiedOutOfRange = Boolean(
    participantNotifiedDate
      && courseStart
      && courseEnd
      && (participantNotifiedDate < courseStart || participantNotifiedDate > courseEnd)
  );

  const participantNotifiedBeforeReports = Boolean(
    participantNotifiedDate
      && latestReportDate
      && participantNotifiedDate < latestReportDate
  );

  const missingDetailedReason = requireFinalize && !String(form?.detailedReasonText || '').trim();
  const missingReports = requireFinalize && completedReportCount === 0;
  const missingHearingUsers = requireFinalize && (!Array.isArray(form?.hearingUserIds) || form.hearingUserIds.length === 0);
  const missingExclusionConfirmed = requireFinalize && !Boolean(form?.exclusionConfirmed);
  const missingParticipantNotifiedDate = requireFinalize && !participantNotifiedDate;

  return {
    incompleteReportIndexes,
    outOfRangeReportIndexes,
    participantNotifiedOutOfRange,
    participantNotifiedBeforeReports,
    missingDetailedReason,
    missingReports,
    missingHearingUsers,
    missingExclusionConfirmed,
    missingParticipantNotifiedDate,
    hasErrors: incompleteReportIndexes.length > 0
      || outOfRangeReportIndexes.length > 0
      || participantNotifiedOutOfRange
      || participantNotifiedBeforeReports
      || missingDetailedReason
      || missingReports
      || missingHearingUsers
      || missingExclusionConfirmed
      || missingParticipantNotifiedDate,
  };
}